import { makeid } from 'utils/helpers/makeid';

import {
  additionalFollowUpItem,
  freeTextCommentsItem,
  isPatientCROorDNCItem,
  needEscalateItem,
  twoWaySyncInfoItem,
  uniqueDaysItem,
} from '../common';

import type { TFormItem } from '../../types';

export const glucose: TFormItem[] = [
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average glucose this week? <span>__ mg/dL</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'glucoseAvg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'glucoseAvg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'glucoseAvg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Were all glucose readings this week within the target range for this
        patient?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'glucoseWithinRange',
    options: [
      { label: 'Yes', value: true, key: makeid(10) },
      {
        label: 'No (add context in free text if relevant)',
        value: false,
        key: makeid(10),
      },
    ],
    items: [
      {
        type: 'textarea',
        name: 'glucoseWithinRangeComment',
        title: null,
        key: makeid(10),
      },
    ],
  },
  { ...uniqueDaysItem('glucose') },
  { ...twoWaySyncInfoItem },
  { ...isPatientCROorDNCItem },
  { ...additionalFollowUpItem },
  { ...needEscalateItem },
  { ...freeTextCommentsItem },
];
